export class StringConstants {
	public static savingScreenStatus = 'saving';
	public static invalidScreenStatus = 'invalid';
	public static loadingScreenStatus = 'loading';
	public static loadingMessage = 'Loading...';
	public static saveSuccessMessage = 'Successful Save';
	public static gridNotLoadedMessage = 'Enter a search term above to see results.';
	public static noDataFoundMessage = 'No records available.';
	public static errorMessage = 'An unexpected error occurred while retrieving tasks';
	public static noTaskScheduledMessage = 'No Tasks Scheduled';
	public static noAnnouncementsMessage = 'No announcements at this time.';
	public static noAnnouncementsDashboardMessage = 'No new announcements. To view all past announcements, please go to ';
	public static loadingAudit = 'Loading audit... please wait';
	public static savingAudit = 'Saving audit... please wait';
	public static hideNotificationAfter = 8000;
	public static hideAuditNotificationAfter = 4000;
	public static hideFileNotificationAfter = 2000;
	public static invalidSignInMessage = 'Username, Company ID or Password entered is incorrect.';
	public static invalidResetPasswordMessage = 'Username or Company ID entered is incorrect.';
	public static whitelistMessage = 'Whitelist this website and then retry login details.';
	public static ssoUnavailableMessage = 'SSO login is currently unavailable. Please try again or use standard login.';
	// Shown when SSO was switched off for the company after this page was loaded — a deliberate
	// administrative change, not a fault, so it reads differently from the message above.
	public static ssoDisabledMessage = 'SSO login is currently disabled. Please use standard login.';
	public static ssoFailedMessage = 'SSO authentication failed. Please try again or contact support.';
}
